import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle,
    Button,
    Label
} from "reactstrap"
import { ConfirmAlert } from '../../../../../helpers/ui/alert'
import { Link, Redirect } from "react-router-dom"

import apiResponse from '../../../../../services/apiResponse'
import { cancelToken } from '../../../../../services/adapters/kepegawaian/menuService'
import Shimmer from 'react-shimmer-effect'
import IndexBloc from '../Index/Blocs/IndexBloc'
import DetailBloc from './Blocs/DetailBloc'
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table"
import { count } from 'rxjs'

const satuanWaktu = [
    { value: 'Hari', label: 'Hari' },
    { value: 'Minggu', label: 'Minggu' },
    { value: 'Bulan', label: 'Bulan' },
]

const reformatDate = (date, withDay = false) => {
    const months = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
    ];
    const days = [
        "Minggu",
        "Senin",
        "Selasa",
        "Rabu",
        "Kamis",
        "Jum'at",
        "Sabtu"
    ]

    const d = new Date(date);

    let dt = d.getDate()
    if (dt < 10)
        dt = '0' + dt

    let day = ''
    if (withDay) {
        day = days[d.getDay()] + ", "
    }

    if (date) {
        return day + dt + " " + months[d.getMonth()] + " " + d.getFullYear();
    }

    return '-'
};

class DetailView extends Component {

    // Retrieve Data Pegawai by Admin / Pegawai
    userdata = JSON.parse(localStorage.getItem('userdata'));
    employeeSeleted = JSON.parse(localStorage.getItem('employeeSelected'));
    peg_uuid = this.userdata != null ? this.userdata.employee_uuid : ""

    queryParams = new URLSearchParams(window.location.search)

    source
    indexBloc = new IndexBloc()
    detailBloc = new DetailBloc()
    timer

    constructor(props) {
        super(props)
        this.state = {
            modal: false,
            detail: null,
            typeOption: [],
            signatoriesOption: [],
            quotaList: [],
            sisa_cuti: 0
        }
    }

    toggle = () => {
        this.setState({ modal: !this.state.modal })
    }

    confirmResponse = (response) => {
        let forState = {}

        switch (response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
            case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:
        }
        this.setState(forState)
    }

    loadKuota = async () => {
        await this.indexBloc.fetchKuotaTahunan({ uuid: this.props.uuid })
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadKuota()
    }

    componentDidMount = () => {
        this.setTokenAPI()

        this.indexBloc.kuotaChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    let response = result.data.response;
                    if (response) {
                        this.setState({
                            quotaList: response.list,
                            sisa_cuti: response.sisa,
                            employee: response.employee
                        })
                    }
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })
    }

    componentWillUnmount = () => {
        this.indexBloc.kuotaChannel?.unsubscribe()
    }

    render() {
        const { detail } = this.state

        let back_link = `/izinpegawai/cuti.html`;
        if (this.queryParams.get('ref') != null) {
            back_link = `/izinpegawai/cuti.html?${this.queryParams.get('ref')}`;
        }

        return (

            <Fragment>
                <Container fluid>
                    <Row>
                        <Col md="12">
                            <Card>
                                <CardBody>
                                    <div className="float-end">
                                        <Link to='/izinpegawai/cuti.html'>
                                            <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                        </Link>
                                    </div>
                                    <CardTitle>Informasi Saldo Cuti</CardTitle>
                                    <hr />
                                    <Row className="mb-3">
                                        <label className="col-md-2">
                                            NIP
                                        </label>
                                        <Col md="5">
                                            {
                                                this.state.employee ?
                                                    this.state.employee?.employee_nip
                                                    : <Shimmer><div style={{ width: '50%', height: 15 }}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-2">
                                            Nama
                                        </label>
                                        <Col md="6">
                                            {
                                                this.state.employee ?
                                                    this.state.employee?.employee_full_name
                                                    : <Shimmer><div style={{ width: '50%', height: 15 }}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Label
                                            className="col-md-2 col-form-label"
                                        >
                                            Saldo Cuti Tahunan
                                        </Label>
                                        <Col md="5">
                                            <div className="table-responsive" style={{ minWidth: '100%' }}>
                                                <Table className='table table-striped table-bordered table-hover'>
                                                    <thead>
                                                        <tr>
                                                            <th className='text-center'>Tahun</th>
                                                            <th className='text-center'>Digunakan</th>
                                                            <th className='text-center'>Sisa</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            this.state.quotaList.map((item, key) => {
                                                                return (
                                                                    <tr>
                                                                        <td className='text-center'>{item.tahun}</td>
                                                                        <td className='text-center'>{item.digunakan}</td>
                                                                        <td className='text-center'>{item.saldo_cuti}</td>
                                                                    </tr>
                                                                )
                                                            })
                                                        }
                                                        <tr>
                                                            <th colSpan={2} className='text-center'>Saldo</th>
                                                            <td className='text-center'>
                                                            <b>{this.state.sisa_cuti}</b> dari ({this.state.quotaList[((this.state.quotaList.length)-1)]?.total_saldo_cuti})
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            </div>

                                        </Col>
                                    </Row>

                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>


                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin data tersebut sudah benar?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                {this.state.redirect ?
                    <Redirect to={'/izinpegawai/cuti.html'} />
                    : null}

            </Fragment>
        )
    }

}

export default DetailView 